import React from 'react';
import { IMenuProps } from '../MenuProps';
import StepIndicator from './StepIndicator/StepIndicator';
import { MenuContainer, MenuInnerContainer, MenuMainContent } from './MenuLUXE-styled';
import { MenuFooter } from './MenuFooter/MenuFooter';
import { Materials, Dimensions, Stones, Engraving } from './TabsLUXE/Tabs';
import { OuterFooter } from './OuterFooter/OuterFooter';
import { isMobile } from '../shared/UIHelpers/Functions/Functions';
//We need an explicit "import '../styles'" to force import of mediaSize for styled-components, even though VSCode thinks it is never used
//See: https://github.com/microsoft/TypeScript/issues/9191
import '../../styles';
import { ShortLinkModal } from './Modals/ModalsLUXE';
//--


export interface ILuxeMenuTab {
	title:string,
	icon?:string,
	content:any
}

interface State {
	fullscreen:boolean,
	menuHeight:number,
	menuScaleFactor:number
};

export default class MenuLuxe extends React.Component<IMenuProps,State> {
	public containerRef:React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: IMenuProps) {
    super(props);
    this.state = {
			fullscreen: false,
			menuHeight: window.innerHeight/2,
			menuScaleFactor: 1
    };
  };

	componentDidMount = async () => {
		window.addEventListener("resize", this.resize);
		await this.resize(); //This is ugly, be we need to ensure this.resize() is called after everything is fully rendered once, to guarantee menuHeight is correct.
		this.resize();
	};

	resize = ():Promise<void> => {
		return new Promise((resolve, reject) => {
			if (this.props.currentMenuTab === -1) {
				this.props.onMenuTabChange(0);
			} else {
				//We always want to call onMenuTabChange for its side effects
				this.props.onMenuTabChange(this.props.currentMenuTab);
			}

			let menuHeight:number = window.innerHeight/2;
			if (this.containerRef.current) menuHeight = this.containerRef.current.getBoundingClientRect().height;

			const menuScaleFactor = Math.min(menuHeight/420, 1);

			this.setState({
				menuHeight: menuHeight,
				menuScaleFactor: menuScaleFactor
			}, () => {
				resolve();
			})
		})
	};

	setFullscreen = (value:boolean) => {
		this.setState({
			fullscreen: value
		}, () => {
			//FIXME
		})
	}

  onTabSelect = (current:number) => {
    this.props.onMenuTabChange(current);
  };

  onTabSelectMobileVersion = (current: number) => {
		const currentMenuTab = current === this.props.currentMenuTab ? -1 : current;
		this.props.onMenuTabChange(currentMenuTab);
	};

	getTabList = ():ILuxeMenuTab[] => {
		const { 
			metalGroups, 
			onMetalGroupChange, 
			limitedMaterials, 
			assetURI,

			fingerSize,
			fingerSizeOptions,
			onFingerSizeChange,
			fingerSizeFormat,
			fingerSizeFormatOptions,
			onFingerSizeFormatChange,
			ringWidth,
			ringWidthOptions,
			onRingWidthChange,
			ringThickness,
			ringThicknessOptions,
			onRingThicknessChange,
			checkoutIssues,

			stoneCut,
			stoneCount,
			stoneCountOptions,
			onStoneCountChange,
			stoneSize,
			stoneSizeOptions,
			onStoneSizeChange,
			stoneGroups,
			onStoneGroupChange,

			engravingText,
			onEngravingTextChange,
			engravingFont,
			engravingFontOptions,
			onEngravingFontChange
		} = this.props;

		const { menuHeight, menuScaleFactor } = this.state;

		const mobile = isMobile();

		const tabs = [];

		//MetalGroups first
		metalGroups.forEach((metalGroup) => {
			tabs.push({
				title: 'Materials',
				icon: 'materials',
				content: <Materials
					metalGroup={metalGroup}
					onMetalGroupChange={onMetalGroupChange}
					limitedMaterials={limitedMaterials}
					assetURI={assetURI}
					mobile={mobile}
					menuHeight={menuHeight}
					menuScaleFactor={menuScaleFactor}
				/>,
			})
		})

		//Dimensions second
		tabs.push({
			title: 'Dimensions',
			icon: 'dimensions',
			content: <Dimensions
				fingerSize={fingerSize}
				fingerSizeOptions={fingerSizeOptions}
				onFingerSizeChange={onFingerSizeChange}
				fingerSizeFormat={fingerSizeFormat}
				fingerSizeFormatOptions={fingerSizeFormatOptions}
				onFingerSizeFormatChange={onFingerSizeFormatChange}
				ringWidth={ringWidth}
				ringWidthOptions={ringWidthOptions}
				onRingWidthChange={onRingWidthChange}
				ringThickness={ringThickness}
				ringThicknessOptions={ringThicknessOptions}
				onRingThicknessChange={onRingThicknessChange}
				checkoutIssues={checkoutIssues}
				mobile={mobile}
				menuHeight={menuHeight}
				menuScaleFactor={menuScaleFactor}
			/>
		});

		//Stones third - if needed
		if (stoneCount > 0 || stoneCountOptions.length > 1) {
			tabs.push({
				title: 'Stones',
				icon: 'stones',
				content: <Stones
					stoneCut={stoneCut}
					stoneCount={stoneCount}
					stoneCountOptions={stoneCountOptions}
					onStoneCountChange={onStoneCountChange}
					stoneSize={stoneSize}
					stoneSizeOptions={stoneSizeOptions}
					onStoneSizeChange={onStoneSizeChange}
					stoneGroups={stoneGroups}
					onStoneGroupChange={onStoneGroupChange}
					assetURI={assetURI}
					mobile={mobile}
					menuHeight={menuHeight}
					menuScaleFactor={menuScaleFactor}
				/>,
			})
		}

		//Engraving last
		tabs.push({
			title: 'Engraving',
			icon: 'engraving',
			content: <Engraving
				engravingText={engravingText}
				onEngravingTextChange={onEngravingTextChange}
				engravingFont={engravingFont}
				engravingFontOptions={engravingFontOptions}
				onEngravingFontChange={onEngravingFontChange}
				mobile={mobile}
				menuHeight={menuHeight}
				menuScaleFactor={menuScaleFactor}
			/>
		})

		return tabs;
	}

  render() {
    const { 
		currentMenuTab,
		price,
		onCheckout,
		modelFullscreen,
		onShareButtonClick,
		shortLinkModalVisible,
		setShortLinkModalVisibility,
		shortLink,
		setModelFullscreen
	} = this.props;

	const { menuHeight, menuScaleFactor } = this.state;

	const tabs = this.getTabList();
	const mobile = isMobile();

    return (
			<React.Fragment>
				{/* FIXME: REMOVE */}
				{/* <div style={{ position: "fixed", top: 0, left: 0, backgroundColor: "lightCoral" }}>{menuHeight}, {menuScaleFactor}</div> */}

				{!modelFullscreen &&
					<MenuContainer className="menu-luxe threed-configurator-menu-container"
						ref={this.containerRef}
						mobile={mobile}
						menuHeight={menuHeight}
					>
						<MenuInnerContainer className="threed-configurator-menu-main">
							<StepIndicator
								tabs={tabs}
								currentMenuTab={currentMenuTab}
								mobile={mobile}
								menuScaleFactor={menuScaleFactor}
							/>
							<MenuMainContent className="threed-configurator-menu-content-container">
								{currentMenuTab >= 0 && tabs[currentMenuTab].content}
							</MenuMainContent>

							<MenuFooter
								price={price}
								tabs={tabs}
								currentMenuTab={currentMenuTab}
								onTabSelect={this.onTabSelect}
								onCheckout={onCheckout}
								mobile={mobile}
								menuHeight={menuHeight}
								menuScaleFactor={menuScaleFactor}
							/>
						</MenuInnerContainer>
					</MenuContainer>
				}
				
				<OuterFooter
					modelFullscreen={modelFullscreen}
					onShareButtonClick={onShareButtonClick}
					setModelFullscreen={setModelFullscreen}
					price={price}
					mobile={mobile}
					menuHeight={menuHeight}
					menuScaleFactor={menuScaleFactor}
				/>

				<ShortLinkModal
					shortLinkModalVisible={shortLinkModalVisible}
					shortLink={shortLink}
					setShortLinkModalVisibility={setShortLinkModalVisibility}
				/>
			
			</React.Fragment>
    );
  }
};
